export const getContent = (content, key, language) => {
  return content?.[`${key}_${language}`] || content?.[`${key}`] || '';
}